import type { Bonus } from '../types/product';

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Emergency Visual Plate',
    description: 'A quick visual reference to pause a session, keep role boundaries clear, and connect with local support.',
    note: 'Not a triage or crisis protocol.',
    cover: 'https://cdn.magicpatterns.com/uploads/wnopL5aPf4AM4ysLpkEtr1/Bonus_1.png',
  },
  {
    number: '02',
    title: 'Topical Guide',
    description: 'Product literacy: reading the exact label, checking ingredients, and handling products cleanly.',
    note: 'No dosage, mixing, or efficacy claims.',
    cover: 'https://cdn.magicpatterns.com/uploads/qiAqBSUhSmfqtrz1na2JdM/Bonus_2.png',
  },
  {
    number: '03',
    title: 'Crisis Record',
    description: 'A factual template for what was said, observed, done, and agreed as next steps.',
    note: 'Not a risk assessment or legal form.',
    cover: 'https://cdn.magicpatterns.com/uploads/wuWYvcthqp9yxnNfWq2Vh8/bonus_3.png',
  },
  {
    number: '04',
    title: 'Therapist’s Shield',
    description: 'A reflection workbook on workload, boundaries, transitions, and recovery habits.',
    note: 'Not a diagnostic or therapeutic tool.',
    cover: 'https://cdn.magicpatterns.com/uploads/cWYgJJR3o5T6wdf9ZF9reE/Bonus_4.png',
  },
  {
    number: '05',
    title: 'Business Masterclass',
    description: 'Service design, fee planning, booking, ethical visibility, and a 90-day action plan.',
    note: 'No revenue or booking promises.',
    cover: 'https://cdn.magicpatterns.com/uploads/9V88BqHsNn8Tjv9gsW3CDb/Bonus_5.png',
  },
];
